// The loyalty backend prefixes these level keys with "member" once a journey is enrolled, so the same
// data arrives under two names. Member-only fields stay: memberJourneyStatus still marks enrollment.
const LEVEL_KEY_ALIASES = {
    memberJourneyActions: 'journeyActions',
    memberJourneyBadge: 'journeyBadge',
    memberJourneyRewards: 'journeyRewards',
};

function normalizeLevel(level) {
    const normalized = {...level};

    for (const [memberKey, key] of Object.entries(LEVEL_KEY_ALIASES)) {
        if (!(memberKey in normalized)) continue;

        normalized[key] = normalized[memberKey];
        delete normalized[memberKey];
    }

    return normalized;
}

function normalizeMemberJourneys(memberJourneys) {
    return (memberJourneys || []).map((journey) => ({
        ...journey,
        journeyLevels: (journey.journeyLevels || []).map(normalizeLevel),
    }));
}

export {normalizeMemberJourneys};
